import { Chip, ChipProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { getProviderStyle } from 'helpers/ProviderStylesHelper';

type ProviderChipProps = Omit<ChipProps, 'label'> & {
  provider: string;
};

export default function ProviderChip({ provider, sx, ...chipProps }: ProviderChipProps) {
  const providerStyle = getProviderStyle(provider);

  return (
    <Chip
      size="small"
      variant="outlined"
      label={providerStyle.label}
      sx={{
        height: 24,
        border: '1.5px solid',
        bgcolor: providerStyle.bg,
        color: providerStyle.text,
        borderColor: alpha(providerStyle.text, 0.35),
        borderRadius: '10px',
        '& .MuiChip-label': {
          px: 0.75,
          py: 0,
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: 'normal',
        },
        ...sx,
      }}
      {...chipProps}
    />
  );
}